import moment from 'moment';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UiQuestionnaireLayout, Col, UiText, Row, UiButton, AppDatePicker, UiBox} from '~/components/elements';
import {ScrollToBottomButton} from '~/components/shared/ScrollToBottomButton';
import {VAGINAL_DRYNESS_TREATMENT_KEYS, YES_OPTION} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setQuestionnaireAnswer, setNextQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire6Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === VAGINAL_DRYNESS_TREATMENT_KEYS.HAVING_REGULAR_PERIODS);

  const currentAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[VAGINAL_DRYNESS_TREATMENT_KEYS.HAVING_REGULAR_PERIODS]?.data,
  );

  const {inputs, setInputs} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
    lastStartDatePeriod: currentAnswer?.lastStartDatePeriod || new Date().toISOString(),
  });

  const onChange = (dates: Date) => {
    setInputs({lastStartDatePeriod: dates.toISOString()});
  };

  const onClickSubmit = () => {
    const data = inputs?.selectedOption === YES_OPTION ? inputs : {selectedOption: inputs?.selectedOption};
    dispatch(
      setQuestionnaireAnswer({
        key: VAGINAL_DRYNESS_TREATMENT_KEYS.HAVING_REGULAR_PERIODS,
        index: questionnaire?.index || '',
        data,
      }),
    );
    dispatch(setNextQuestionnaire({value: VAGINAL_DRYNESS_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING}));
  };
  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!inputs?.selectedOption}
    >
      <Col alignItems="center" textAlign="center">
        <UiText my={10} variant="mdqTitle">
          {questionnaire?.questions?.default}
        </UiText>
        <Row justifyContent="center" w="100%">
          {questionnaire?.options?.map(value => (
            <UiButton
              onClick={() => setInputs({selectedOption: value?.value})}
              key={`${value.label}-${value.value}`}
              title={value?.label}
              mb={4}
              variant={inputs?.selectedOption === value.value ? 'solid' : 'toggle'}
              w="100%"
              mx={1}
            />
          ))}
        </Row>
        {inputs?.selectedOption === YES_OPTION && (
          <>
            <UiText mt={spacing.smedium} variant="mdqTitle">
              {questionnaire?.questions?.sub}
            </UiText>
            <UiBox mt={spacing.xmedium}>
              <AppDatePicker
                maxDate={moment().toDate()}
                selected={inputs.lastStartDatePeriod}
                onChange={onChange}
                inline
              />
            </UiBox>
          </>
        )}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire6Screen;
